export class RelatedCompaniesModel {
    uid: number;
    nameOrBusinessName: string;
    accountsTypeGroup: string;
    accountingModels: string;
}

export class TransactionModel {
    uid: number;
    RelatedCompaniesId: number;
    date: Date;
    amount: number;
    bankAccountsUid: string;
    typePay: string;
    commissions: number;
    bankAccountInfo: string;
    transactionType: boolean;
    efectivoId: string;
    partnersId: number;
  }
